import type { ReactNode } from 'react'

interface SkipLinkProps {
  /** Fragment target id of the main content region, e.g. "main-content". */
  targetId?: string
  children?: ReactNode
}

/**
 * Accessible skip-to-content link (KAN-1178). Visually hidden until focused via the
 * `.skip-link` rule in tokens.css. Render it as the FIRST focusable element in a
 * portal shell, and give the main content region a matching `id` + `tabIndex={-1}`.
 */
export function SkipLink({ targetId = 'main-content', children = 'Skip to main content' }: SkipLinkProps) {
  return (
    <a className="skip-link" href={`#${targetId}`}>
      {children}
    </a>
  )
}

export default SkipLink
